<template>
  <div class="base-page">
    <slot></slot>
  </div>
</template>

<script>
// Envoltorio mínimo: la portada es el mapa a pantalla completa, así que no hay
// menú. Cuando haya más vistas, el menú va acá.
export default {
  name: 'BasePage',
  props: {
    showMenu: { type: Boolean, default: true },
  },
};
</script>

<style>
html, body, #app, .base-page {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
